var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-sidebar",
          {
            staticClass: "prevent-unselect",
            attrs: {
              "sidebar-class": "h-100 border-left",
              "body-class": "custom-sidebar",
              "bg-variant": "white",
              "z-index": "1000",
              title: _vm.htmlTemplateName,
              "footer-class": ["px-3 py-2", { "d-none": !_vm.target }],
              width: _vm.width,
              right: _vm.right,
              "no-header-close": "",
              "no-close-on-esc": "",
            },
            on: {
              change: function ($event) {
                return _vm.$emit("toggle")
              },
            },
            model: {
              value: _vm.visible,
              callback: function ($$v) {
                _vm.visible = $$v
              },
              expression: "visible",
            },
          },
          [
            _vm.selectedInstance
              ? _c(
                  "b-tabs",
                  {
                    staticClass: "no-gutters",
                    attrs: {
                      "nav-wrapper-class": "layout-sidebar-nav-wrapper",
                      "content-class": "px-3 py-2",
                      small: "",
                      pills: "",
                      vertical: "",
                      end: "",
                      "nav-class": _vm.target ? "" : "no-target",
                    },
                    model: {
                      value: _vm.tabIndex,
                      callback: function ($$v) {
                        _vm.tabIndex = $$v
                      },
                      expression: "tabIndex",
                    },
                  },
                  [
                    _c(
                      "b-tab",
                      [
                        _c("BannerBuilderEditor", {
                          attrs: {
                            "is-open": _vm.isOpen,
                            target: _vm.backgroundColorRectangle,
                            "active-target": _vm.target,
                            options: _vm.options,
                            themes: _vm.themes,
                            "type-editor-control": _vm.typeEditorControl,
                          },
                          on: {
                            toggleSection: _vm.toggleSection,
                            update: _vm.updateControlEditor,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }